import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';
import bindPendingReferral from '../utils/referralBind';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  // 微信网页 OAuth 回调：URL 参数中带 token 和 user
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const userStr = params.get('user');
    if (token && userStr) {
      try {
        const userData = JSON.parse(decodeURIComponent(userStr));
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(userData));
        setUser(userData);
        bindPendingReferral(); // 服务端 OAuth 重定向路径的归因补绑
        const scan = params.get("scan");
        if (scan) {
          fetch("/api/auth/wx-scan/confirm", {
            method: "POST",
            headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
            body: JSON.stringify({ scene: scan, user: userData }),
          }).finally(function () { window.location.replace("/auction-hub"); });
          return;
        }
        if (window.location.pathname === "/login") { window.location.replace("/auction-hub"); return; }
        // 清除 URL 参数
        const url = new URL(window.location);
        url.searchParams.delete('token');
        url.searchParams.delete('user');
        window.history.replaceState({}, '', url.toString());
      } catch {}
    }
  }, []);

  const login = async (phone, password) => {
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { phone, password });
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      setUser(data.user);
      bindPendingReferral(); // 兜底:注册时绑定失败的用户,7天窗口内再次登录可补绑
      // 补拉完整 profile(含 distribution_role 等登录响应没有的字段)
      api.get('/customers/me').then(({ data: me }) => {
        const merged = { ...data.user, ...me };
        localStorage.setItem('user', JSON.stringify(merged));
        setUser(merged);
      }).catch(() => {});
      return data;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const { data } = await api.get('/customers/me');
      const updated = { ...user, ...data };
      localStorage.setItem('user', JSON.stringify(updated));
      setUser(updated);
    } catch {}
  };

  // 老会话自愈:登录态存在但缺 distribution_role(P2 新增字段)时补拉一次,
  // 使"推广此拍品"/合作伙伴入口等按角色显隐的 UI 拿到角色
  useEffect(() => {
    if (user && user.id && user.distribution_role === undefined) refreshUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshUser, isLoggedIn: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
